export default "__VITE_ASSET__CC_289p3__"